export default {
  props: {
    dataList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    handleClick: function handleClick(item) {
      if (item.questionType === '0') {
        this.$emit('send', item.question);
      }
    }
  }
};